/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommButtonData } from './ecomm-button.data';
import { IEcommButtonProps } from './ecomm-button.props.autogenerated';

export interface IEcommButtonViewProps extends IEcommButtonProps<IEcommButtonData> {}

/**
 *
 * EcommButton component
 * @extends {React.PureComponent<IEcommButtonProps<IEcommButtonData>>}
 */
class EcommButton extends React.PureComponent<IEcommButtonProps<IEcommButtonData>> {
  public render(): JSX.Element | null {
    return this.props.renderView(this.props);
  }
}

export default EcommButton;